import { mentionDocExtension, mentionTranscriptionExtension, imageExtension } from './chunk-BR7MVISI.js';
import { BaseEditorExtension, mentionExtension } from './chunk-7Q5SUUV6.js';
import { getSchema } from '@tiptap/core';

var basicEditorExtensions = [
  BaseEditorExtension.configure(),
  mentionExtension.configure(),
  mentionDocExtension.configure(),
  mentionTranscriptionExtension.configure(),
  imageExtension.configure()
];
var basicEditorSchema = getSchema(basicEditorExtensions);

export { basicEditorSchema };
